import styled from 'styled-components';

export interface IStyledTextField {
}

export const StyledTextField = styled.div<IStyledTextField>`
`;
